import { UtilsService } from "@/services/utils/utils.service";
import { authorizedAPI } from "@/config/axios.config";
import type { Company } from "@/types/user.types";

const utils = new UtilsService();

export interface CreateCompanyDto {
  name: string;
  address?: string;
  website?: string;
  phone?: string;
}

export interface UpdateCompanyDto {
  name?: string;
  address?: string;
  website?: string;
  phone?: string;
}

class CompanyService {
  createCompany(data: CreateCompanyDto) {
    return utils.handleApiRequest(() =>
      authorizedAPI.post<Company>("/company", data)
    );
  }

  getCompany() {
    return utils.handleApiRequest(() =>
      authorizedAPI.get<Company | null>("/company")
    );
  }

  updateCompany(companyId: string, data: UpdateCompanyDto) {
    return utils.handleApiRequest(() =>
      authorizedAPI.put<Company>(`/company/${companyId}`, data)
    );
  }

  getMembers() {
    return utils.handleApiRequest<Array<{
      id: string;
      email: string;
      firstName: string | null;
      lastName: string | null;
      photo: string | null;
      status: string;
      createdAt: string;
    }>>(() =>
      authorizedAPI.get("/company/members")
    );
  }

  deleteCompany(companyId: string) {
    return utils.handleApiRequest<{ success: boolean }>(() =>
      authorizedAPI.delete(`/company/${companyId}`)
    );
  }
}

export const companyService = new CompanyService();

